module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать шаблон квитанции\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'bill-template-details',
        params: {
          id: _vm.bill_template.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям шаблона квитанции")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.bill_template.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteBillTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить шаблон квитанции")]) : _vm._e()]), _vm._v(" "), _c('bill-template-edit-form', {
    attrs: {
      "bill-template": _vm.bill_template
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d823fda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill_template/BillTemplateEdit.vue
// module id = 639
// module chunks = 0